// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--2vbRQ","logo":"layout-module--logo--2S9KC"};